"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner, toast } from "sonner";
/**
 * Toaster — mount once near the app root. Fire toasts imperatively with the
 * re-exported `toast()` API (`toast.success`, `toast.error`, ...).
 *
 * Theming is token-driven: Sonner's internal CSS custom properties are mapped
 * onto the OwlCat design tokens, so toasts follow light/dark automatically via
 * the same `.dark` / `[data-theme='dark']` cascade as every other primitive —
 * no next-themes dependency required. Pass `theme` to force a mode if needed.
 */
const Toaster = ({ ...props }) => (_jsx(Sonner, { className: "toaster group", style: {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--success-bg": "var(--success)",
        "--success-text": "var(--success-foreground)",
        "--error-bg": "var(--destructive)",
        "--error-text": "var(--destructive-foreground)",
        "--border-radius": "var(--radius)",
    }, ...props }));
export { Toaster, toast };
